import Layout from "layouts/Layout.vue"
import InnerLayout from "layouts/InnerLayout.vue"
import { Home, Login, Logout, Registration, NotFound, Forgot, Reset, Confirm, Unsubscribe, Invoice, Review, TgComplete } from "components"
import { Features, FAQ, Status, Contact, Pricing, Showcase, CacheAPI, MCP, Datasets, Docs, DocsCacheAPI, DocsMCP, DocsDatasets, DocsDatasetBuilder, Blog, BlogPost, Changelog } from "components"
import { Dashboard, Tokens, AffPromoCodes, AffOrderPayout, Billing, Settings, Plan, ChoosePlan, Pay, ConnectedApps } from "components/inner"
import { DatasetBuilder } from "components/inner"

export default [
    {
        path: "/",
        name: "Outer",
        redirect: "/",
        component: Layout,
        children: [
            {
                path: "/login",
                name: "Login",
                component: Login,
                meta: {
                    title: "Login",
                    description: "Sign in to DataLikers to access Instagram and TikTok data API, manage your tokens, and download datasets.",
                    noindex: true
                },
            },
            {
                path: "/forgot",
                name: "Forgot",
                component: Forgot,
                meta: {
                    title: "Forgot Password",
                    description: "Reset your DataLikers account password.",
                    noindex: true
                },
            },
            {
                path: "/reset/:uid/:token",
                name: "Reset",
                component: Reset,
                meta: {
                    title: "Reset Password",
                    noindex: true
                },
            },
            {
                path: "/confirm/:uid/:token",
                name: "Confirm",
                component: Confirm,
                meta: {
                    title: "Confirm Email",
                    noindex: true
                },
            },
            {
                path: "/unsubscribe/:uid/:token/:code",
                name: "Unsubscribe",
                component: Unsubscribe,
                meta: {
                    title: "Unsubscribe",
                    noindex: true
                },
            },
            {
                path: "/logout",
                name: "Logout",
                component: Logout,
                meta: {
                    title: "Logout",
                    noindex: true
                },
            },
            {
                path: "/registration",
                name: "Registration",
                component: Registration,
                meta: {
                    title: "Sign Up - Create Your Account",
                    description: "Create a free DataLikers account. Get 100 free API requests after Telegram verification. Access Instagram and TikTok data instantly.",
                    keywords: "sign up, register, create account, Instagram API, TikTok API, free trial"
                },
            },
            {
                path: "/tg-complete",
                name: "TgComplete",
                component: TgComplete,
                meta: {
                    title: "Complete Registration",
                    description: "Complete your Telegram login registration.",
                    noindex: true
                },
            },
            {
                path: "/404",
                name: "404",
                component: NotFound,
                meta: {
                    title: "Page Not Found",
                    noindex: true
                },
            },
            {
                path: "/",
                name: "Home",
                component: Home,
                meta: {
                    title: "Instagram & TikTok Data API",
                    description: "Access Instagram and TikTok data at scale. Fast Cache API, AI-powered MCP Server for Claude, and ready-made datasets. No rate limits, no blocks. From $0.0003 per request.",
                    keywords: "Instagram API, TikTok API, social media data, Instagram scraper, TikTok scraper, Instagram datasets, social media analytics"
                },
            },
            {
                path: "/p/:promocode",
                name: "Promo",
                component: Home,
                meta: {
                    title: "Instagram & TikTok Data API",
                    description: "Access Instagram and TikTok data at scale with special promo offer.",
                    noindex: true
                },
            },
            {
                path: "/promo/:promocode",
                name: "PromoHome",
                component: Home,
                meta: {
                    title: "Instagram & TikTok Data API",
                    description: "Access Instagram and TikTok data at scale with special promo offer.",
                    noindex: true
                },
            },
            {
                path: "/features",
                name: "Features",
                component: Features,
                meta: {
                    title: "Features - API Capabilities",
                    description: "Explore DataLikers features: user profiles, posts, reels, stories, followers, following, comments, hashtags, and locations data from Instagram and TikTok.",
                    keywords: "Instagram API features, TikTok API features, user profiles API, posts API, reels API, stories API, followers API"
                },
            },
            {
                path: "/faq",
                name: "FAQ",
                component: FAQ,
                meta: {
                    title: "FAQ - Frequently Asked Questions",
                    description: "Common questions about DataLikers API: pricing, rate limits, data freshness, supported platforms, and integration guides.",
                    keywords: "FAQ, frequently asked questions, Instagram API help, TikTok API help, API documentation"
                },
            },
            {
                path: "/cache-api",
                name: "CacheAPI",
                component: CacheAPI,
                meta: {
                    title: "Instagram & TikTok API - Fast REST API for Social Data | DataLikers",
                    description: "REST API for Instagram and TikTok data: user profiles, posts, comments, stories, reels. No rate limits, no blocks, instant responses. From $0.0003 per request. Free trial with 100 requests.",
                    keywords: "instagram api, tiktok api, cache api, social data api, rest api, instagram scraper, tiktok scraper, instagram profile api, tiktok profile api, instagram posts api, tiktok posts api, instagram public data api, tiktok public data api, bulk instagram data, bulk tiktok data"
                },
            },
            {
                path: "/mcp",
                name: "MCP",
                component: MCP,
                meta: {
                    title: "Instagram & TikTok MCP Server - Claude AI Access to Social Data | DataLikers",
                    description: "Model Context Protocol server for Instagram and TikTok data. Query profiles, posts, comments in natural language from Claude, Cursor, or any MCP client. 27 tools across both platforms, including analytics, demographics, and face analysis.",
                    keywords: "instagram mcp, tiktok mcp, mcp server, social media mcp, model context protocol, claude instagram, claude tiktok, claude desktop instagram, claude desktop tiktok, cursor instagram, cursor tiktok, mcp tools, instagram ai analytics, tiktok ai analytics"
                },
            },
            {
                path: "/datasets",
                name: "Datasets",
                component: Datasets,
                meta: {
                    title: "Instagram & TikTok Datasets - Profiles, Posts, Comments CSV | DataLikers",
                    description: "Ready-made Instagram and TikTok datasets: millions of profiles, posts, comments, engagement data. CSV format, instant download. Custom dataset builder for both platforms. For research, analytics, ML training, and influencer marketing.",
                    keywords: "instagram datasets, tiktok datasets, social media data download, user profile dataset, instagram csv, tiktok csv, instagram posts dataset, tiktok posts dataset, social media analytics data, social media research data, instagram dataset for machine learning, tiktok dataset for machine learning, instagram influencer data, tiktok influencer data"
                },
            },
            {
                path: "/status",
                name: "Status",
                component: Status,
                meta: {
                    title: "API Status - Service Health",
                    description: "Check DataLikers API status and service health. Real-time monitoring of Cache API, MCP Server, and data collection services.",
                    keywords: "API status, service status, uptime, health check"
                },
            },
            {
                path: "/contact",
                name: "Contact",
                component: Contact,
                meta: {
                    title: "Contact DataLikers — Instagram & TikTok Data API",
                    description: "Reach DataLikers support by email or Telegram for billing, API keys, datasets and MCP questions about Instagram and TikTok data, plus service status.",
                    keywords: "DataLikers contact, Instagram data API support, TikTok data API support, DataLikers email"
                },
            },
            {
                path: "/pricing",
                name: "Pricing",
                component: Pricing,
                meta: {
                    title: "MCP & Cache API Pricing - Flexible Plans for Every Need",
                    description: "MCP & Cache API pricing plans. Pay-as-you-go from $0.0003 per request. Volume discounts available. Free trial with 100 requests.",
                    keywords: "API pricing, Instagram API pricing, TikTok API pricing, data API cost, subscription plans"
                },
            },
            {
                path: "/reviews",
                name: "Reviews",
                component: Review,
                meta: {
                    title: "Reviews - Customer Testimonials",
                    description: "Read what our customers say about DataLikers API. Real reviews from developers, researchers, and marketers.",
                    keywords: "reviews, testimonials, customer feedback, API reviews"
                },
            },
            {
                path: "/docs",
                name: "Docs",
                component: Docs,
                meta: {
                    title: "DataLikers Docs - Instagram & TikTok Data API Reference",
                    description: "Complete API documentation for Instagram and TikTok data access: Cache API, MCP Server, Datasets. Code examples in Python, JavaScript, cURL. Authentication and quickstart guides.",
                    keywords: "API documentation, instagram api docs, tiktok api docs, developer reference, datalikers docs, integration guide, code examples"
                },
            },
            {
                path: "/docs/cache-api",
                name: "DocsCacheAPI",
                component: DocsCacheAPI,
                meta: {
                    title: "Cache API Docs - Instagram & TikTok REST Endpoints",
                    description: "Cache API reference for Instagram and TikTok: user profiles, posts, followers, comments endpoints. Code examples in Python, JavaScript, cURL.",
                    keywords: "cache api docs, instagram rest api docs, tiktok rest api docs, rest endpoints reference"
                },
            },
            {
                path: "/docs/mcp",
                name: "DocsMCP",
                component: DocsMCP,
                meta: {
                    title: "MCP Server Docs - Instagram & TikTok Data for Claude AI",
                    description: "Setup guide for the DataLikers MCP Server. Connect Claude, Cursor, or any MCP client to Instagram and TikTok data. Configuration, tool list, and usage examples.",
                    keywords: "mcp documentation, claude instagram mcp, claude tiktok mcp, mcp integration guide, cursor mcp, ai setup"
                },
            },
            {
                path: "/docs/datasets",
                name: "DocsDatasets",
                component: DocsDatasets,
                meta: {
                    title: "Datasets Docs - Instagram & TikTok CSV Data Downloads",
                    description: "Guide to DataLikers Instagram and TikTok datasets: data formats, available fields, download instructions, and data processing tips.",
                    keywords: "datasets documentation, instagram csv fields, tiktok csv fields, data format reference, bulk download guide"
                },
            },
            {
                path: "/docs/dataset-builder",
                name: "DocsDatasetBuilder",
                component: DocsDatasetBuilder,
                meta: {
                    title: "Dataset Builder Docs - Custom Instagram & TikTok Datasets",
                    description: "Build custom Instagram and TikTok datasets with Dataset Builder. Filter by hashtags, locations, user criteria. Export to CSV.",
                    keywords: "dataset builder, custom instagram datasets, custom tiktok datasets, data filtering, data export"
                },
            },
            {
                path: "/blog",
                name: "Blog",
                component: Blog,
                meta: {
                    title: "Blog - Weekly Digest",
                    description: "Weekly digests covering Instagram and TikTok data API updates, scraping news, and platform changes.",
                    keywords: "Instagram API blog, TikTok API blog, weekly digest, data API news"
                },
            },
            {
                path: "/blog/:slug",
                name: "BlogPost",
                component: BlogPost,
                meta: {
                    title: "Blog",
                    description: "Weekly digests covering Instagram and TikTok data API updates, scraping news, and platform changes.",
                    keywords: "Instagram API blog, TikTok API blog, weekly digest, data API news"
                },
            },
            {
                path: "/changelog",
                name: "Changelog",
                component: Changelog,
                meta: {
                    title: "Changelog — Latest Updates",
                    description: "DataLikers changelog. Latest updates, new endpoints, bug fixes, and improvements for the Instagram & TikTok Data API.",
                    keywords: "changelog, updates, release notes, DataLikers updates, new features"
                },
            },
        ]
    },
    {
        path: "/dashboard",
        name: "Inner",
        redirect: "/dashboard",
        component: InnerLayout,
        children: [
            { path: "", name: "Dashboard", component: Dashboard, meta: { title: "Dashboard", noindex: true } },
            { path: "/datasets/builder", name: "DatasetBuilder", component: DatasetBuilder, meta: { title: "Dataset Builder", noindex: true } },
            { path: "/tokens", name: "Tokens", component: Tokens, meta: { title: "Tokens", noindex: true } },
            { path: "/affiliate", name: "Affiliate program", component: AffPromoCodes, meta: { title: "Affiliate program", noindex: true } },
            { path: "/affiliate/order", name: "Order payout", component: AffOrderPayout, meta: { title: "Order payout", noindex: true } },
            { path: "/billing", name: "Billing", component: Billing, meta: { title: "Billing", noindex: true } },
            { path: "/billing/pay", name: "Pay", component: Pay, meta: { title: "Pay", noindex: true } },
            { path: "/plan", name: "Plan", component: Plan, meta: { title: "Plan", noindex: true } },
            { path: "/plan/choose/:id", name: "Choose plan", component: ChoosePlan, meta: { title: "Choose plan", noindex: true } },
            { path: "/settings", name: "Settings", component: Settings, meta: { title: "Settings", noindex: true } },
            { path: "/settings/connected-apps", name: "Connected Apps", component: ConnectedApps, meta: { title: "Connected Apps", noindex: true } },
        ]
    },
    {
        path: "/invoice/:id",
        name: "Invoice",
        component: Invoice,
        meta: {
            title: "Invoice"
        },
    },
    {
        path: "/:pathMatch(.*)*",
        component: NotFound,
        meta: {
            title: "404"
        }
    }
]
